import Vue from "vue";

Vue.filter("correctLang", function(item, type)
{
    const returnval = "";

    if (type === "name")
    {
        const findname = item.texts.filter(text => text.lang === App.language);

        if (findname.length > 0)
        {
            return findname[0].name1;
        }
        else
        {
            const finddefaultname = item.texts.filter(text => text.lang === "en");

            {
                if (finddefaultname.length > 0)
                {
                    return finddefaultname[0].name1;
                }
                else
                {
                    return item.texts[0].name1;
                }
            }
        }
        // returnval = item.texts.filter(text => text.lang === App.language)[0].name1;
    }
    if (type === "url")
    {

        const findUrl = item.texts.filter(text => text.lang === App.language);

        let langPrefix = "";

        if (App.defaultLanguage !== App.language)
        {
            langPrefix = App.language+"/";
        }

        if (findUrl.length > 0)
        {
            return "/"+langPrefix+findUrl[0].urlPath+"_"+item.item.id+"/";
        }
        else
        {
            const finddefault = item.texts.filter(text => text.lang === "en");

            if (finddefault.length > 0)
            {
                return "/"+langPrefix+finddefault[0].urlPath+"_"+item.item.id+"/";
            }
            else
            {
                return "/"+langPrefix+item.texts[0].urlPath+"_"+item.item.id+"/";
            }
        }
    }

    return returnval;
});
